import React from "react";
import { cn } from "../../lib/utils"; // Ensure this utility exists

export const Button = ({ className, children, variant = "default", size = "default", ...props }) => {
  return (
    <button
      className={cn(
        "px-4 py-2 rounded-md font-medium transition-all focus:outline-none",
        variant === "default" && "bg-emerald-500 hover:bg-emerald-600 text-white",
        variant === "ghost" && "bg-transparent shadow-md hover:bg-gray-100",
        size === "icon" && "p-2 rounded-full", 
        className
      )}
      {...props}
    >
      {children}
    </button>
  );
};
